<script setup lang="ts">
import { useQuery } from "@tanstack/vue-query";

interface Props {
  theme: string;
  showTooltip?: boolean;
  size?: "sm" | "lg";
}

const props = withDefaults(defineProps<Props>(), {
  showTooltip: true,
  size: "sm",
});

const { $trpc } = useNuxtApp();

const { advertiserMetadata } = useAdvertiserMetadata({
  advertiserName: props.theme,
});

const { data: mediaSponsor, isSuccess } = useQuery({
  queryKey: ["getAdvertiserByTheme", props.theme],
  queryFn: () =>
    $trpc.getAdvertiserByTheme.query({ advertiserTheme: props.theme }),
});
</script>

<template>
  <div
    class="flex justify-center items-center rounded-full shrink-0 w-full aspect-square"
  >
    <img
      :width="size === 'sm' ? 24 : 96"
      :height="size === 'sm' ? 24 : 96"
      :src="advertiserMetadata.smallLogo"
    />

    <tippy
      v-if="showTooltip && isSuccess"
      to="parent"
      :hide-on-click="false"
      interactive
    >
      <strong>Media sponsor:</strong> {{ mediaSponsor?.mediaSponsorName }}
      <br />
      <strong>Country:</strong> {{ mediaSponsor?.mediaSponsorCountry }}
      <br />
      <strong>Contact:</strong>
      <a
        target="_blank"
        :href="`mailto:${mediaSponsor?.mediaSponsorEmailContact}`"
        class="underline"
        >{{ mediaSponsor?.mediaSponsorEmailContact }}</a
      >
    </tippy>
  </div>
</template>
